import { weenatIntl } from '@weenat/wintl';
import { Resource } from '../Resource';
import { OptionCode } from '../enums';
import * as methods from '../methods';
import * as transformers from '../transformers';
const rootPath = 'seeds';
export const fromRaw = {
    get: (seed) => {
        const maizyPrecocityClass = seed.params?.[OptionCode.maizy]?.precocity_class;
        const isMaizyCompatible = !!seed.params?.[OptionCode.maizy];
        const name = seed.seed_name || seed.crop.name;
        return {
            id: seed.id,
            isDefault: seed.default,
            vendor: seed.vendor,
            name,
            rpgCode: seed.crop.rpg_code,
            rpgSubcode: seed.crop.rpg_subcode,
            version: seed.crop.version_code,
            isPerennial: seed.crop.perennial,
            cropUsage: seed.crop.usage,
            refWeenat: seed.crop.ref_weenat,
            maizyPrecocityClass,
            isMaizyCompatible,
            localizedName: seed.crop.ref_weenat
                ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    weenatIntl.t(`dss.cropTracking.seeds.${seed.crop.ref_weenat}`)
                : name
        };
    }
};
const seeds = Resource((requesterBuilder) => {
    const cacheConfig = {
        staleTime: 10 * 60 * 1000,
        cacheTime: 10 * 60 * 1000
    };
    const getMany = (query) => requesterBuilder({
        path: rootPath,
        requestCtx: {
            transform: transformers.paginatedResponse(fromRaw.get),
            params: {
                query: {
                    q: query?.q,
                    limit: query?.limit,
                    offset: query?.offset,
                    option_code: query?.optionCode,
                    has_precocity_class: query?.hasPrecocityClass
                }
            }
        },
        config: cacheConfig
    });
    return {
        getMany,
        get: methods.get({ requesterBuilder, rootPath, fromRaw: fromRaw.get }),
        getAll: methods.getAllPages({ getMany, cacheConfig })
    };
});
export default seeds;
